/**
 * Replaces ${variableName} placeholders using local overrides (e.g. shared_* keys from SharedData).
 * Only keys present in overrides are substituted; other placeholders are left unchanged.
 */
export function interpolateVariableOverrides(
  text: string,
  overrides: Record<string, string | number>
): string {
  if (!text || !overrides || Object.keys(overrides).length === 0) {
    return text;
  }

  return text.replace(/\$\{([a-zA-Z0-9_]+)\}/g, (match, name: string) => {
    if (!Object.prototype.hasOwnProperty.call(overrides, name)) {
      return match;
    }
    const value = overrides[name];
    if (value === undefined || value === null) {
      return '';
    }
    return String(value);
  });
}
